var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 8.4C0.5 3.8 3.875 0 8 0C12.125 0 15.5 3.8 15.5 8.4C15.2875 11.6346 14.1841 13.1738 12.6859 15.2638C11.5862 16.798 10.2737 18.6289 8.94478 21.6448L8.92481 21.6903C8.61656 22.3925 8.30747 23.1587 8 24C7.71921 23.1293 7.42977 22.3389 7.13535 21.6168L7.13425 21.614L5.23704 17.8352C4.57113 16.7459 3.91905 15.8657 3.32134 15.0589L3.25254 14.966C3.09257 14.75 2.93666 14.539 2.78561 14.3302C1.57722 12.6601 0.679794 11.137 0.5 8.4ZM8 11C9.84095 11 11.5 9.46498 11.5 7.57143C11.5 5.67788 9.84095 4 8 4C6.15905 4 4.5 5.60645 4.5 7.5C4.5 9.39355 6.15905 11 8 11Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.e7019df9533c263ac7a2154140ea3cae.svg";
export { ForwardRef as ReactComponent };